// extracted by mini-css-extract-plugin
export default {"dot":"src-components-ColorDot-style__f2c95__dot","small":"src-components-ColorDot-style__kjrYe__small"};